import { sdkRequest } from '@eventbrite/legacy-infra.http';
import type { FollowStatus, FollowStatusApiResponse } from '@/components/OrganizerCard/types';
import {
  DEFAULT_FOLLOW_STATUS_RESPONSE,
  mapApiResponseToFollowStatus,
} from '@/components/_shared/buttons/FollowButton/utils';

export const fetchOrganizerFollowStatusExpansion = async (organizerId: string | null): Promise<FollowStatus> => {
  if (!organizerId) {
    console.error('FollowButton: Organizer ID is missing');
    return DEFAULT_FOLLOW_STATUS_RESPONSE;
  }

  const response: FollowStatusApiResponse = await sdkRequest(
    `/organizers/${organizerId}/?expand.organizer=follow_status`,
    undefined,
    process.env.NEXT_PUBLIC_PROXY_API_V3 ? '/e' : '',
  );

  if (!response.follow_status) {
    console.error('FollowButton: API response missing follow_status', {
      organizerId,
      response,
    });
    return DEFAULT_FOLLOW_STATUS_RESPONSE;
  }

  return mapApiResponseToFollowStatus(response.follow_status);
};
